export enum RouteType {
  Article = "Article",
  Page = "Page",
  Section = "Section",
  Topic = "Topic",
}
